"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardHomeDetailsList = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _PropertyCardHomeDetailsList = require("./PropertyCardHomeDetailsList.styles");
var _excluded = ["data"];
/**
 * Note: This is for SEO testing purposes only.
 *
 * Displays the home details inside of a `PropertyCard`.
 * While `PropertyCard.HomeDetails` uses `span` elements, this
 * version uses an unordered list.
 *
 * @since 8.79.13
 */
var PropertyCardHomeDetailsList = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var data = _ref.data,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_PropertyCardHomeDetailsList.StyledPropertyCardHomeDetailsList, (0, _extends2.default)({
    ref: forwardedRef
  }, rest), data.map(function (_ref2, index) {
    var label = _ref2.label,
      value = _ref2.value;
    return (
      /*#__PURE__*/
      // eslint-disable-next-line zillow/react/no-array-index-key
      _react.default.createElement("li", {
        key: index
      }, value && /*#__PURE__*/_react.default.createElement("b", null, value), " ", label && label)
    );
  }));
});
exports.PropertyCardHomeDetailsList = PropertyCardHomeDetailsList;
PropertyCardHomeDetailsList.propTypes = {
  /**
   * The home details text you’d like to display.
   *
   * `data` takes an array of objects, each with a key/value pair:
   * `[{ value: '4', label: 'bd' }, { value: '3', label: 'ba' }]`
   *
   * `label` and `value` can take a string or a node. You can also leave
   * either one empty.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  data: _propTypes.default.array.isRequired
};
PropertyCardHomeDetailsList.displayName = 'PropertyCard.HomeDetailsList';